
    <div class="col-md-12 py-5 ">
        <div class="row w-100 text-center d-flex flex-column">
<div class="mx-5">
        <img class="px-3" style="display: block; margin-right: auto; margin-left: auto; max-height: 200px; max-width: 200px;" src="./assets/logo2020w.png" />
    </div>   

        <div class="mx-1">
        <h1 class="text-center bg-black text-white p-5 w-100" style="font-family:'DINPro';" translate >How can we help you today? </h1>
    </div>


    
</div>
        

    







<div class="row py-5 my-1 ">
    <div class="col-xs-12 w-100">
        <div class="d-flex justify-content-between  row w-100 m-0">


            <div class="col-sm-3  ">
                <div class="row border p-1 m-1 h-100  rounded justify-content-between  " routerLink="/covid-assessment" style="background:white;">
                    <div class="w-100 text-center">
                    <i class=" text-center fas fa-calendar-alt fa-5x  p-2" style="color:black;"></i>
</div>
                    <div class="text-center p-0 w-100" routerLink="/asset-tangible">
                        <h4  style="font-family:'DINPro'; color: black; ">I have an appointment</h4>
                    
                       
                    </div>
                </div>


            
            </div>
<!---------------------------------------------------------------------------------------------------------------------------------------------------------------------------->


            
<div class="col-sm-3 my-1 ">
    <div class="row border p-1 m-1 h-100 rounded justify-content-between  " style="background:white;">
        <div class="w-100 text-center">
        <i class=" text-center fas fa-user fa-5x  p-2" style="color:black;"></i>
</div>
<div class="text-center p-0 w-100" routerLink="/">
            <h4  style="font-family:'DINPro'; color: black; "> I'm a new client</h4>
        
           
        </div>
    </div>
</div>

<!------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->

<div class="col-sm-3 my-1 ">
    <div class="row border p-1 m-1 h-100 rounded justify-content-between  " style="background:white;">
        <div class="w-100 text-center">
        <i class=" text-center fas fa-sign-out-alt fa-5x  p-2" style="color:black;"></i>
</div>
        <div class="text-center p-0 w-100" routerLink="/">
            <h4  style="font-family:'DINPro'; color: black; ">I'm a returning client</h4>
        
           
        </div>
    </div>
</div>

<!--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->            
<div class="col-sm-3 my-1  ">
    <div class="row border p-1 m-1 h-100 rounded justify-content-between  " style="background:white;">
        <div class="w-100 text-center">
        <i class=" text-center fas fa-th-large fa-5x  p-2" style="color:black;"></i>
</div>
        <div class="text-center p-0 w-100" routerLink="/asset-tangible">
            <h4  style="font-family:'DINPro'; color: black; ">I'm a just browsing</h4>
        
           
        </div>
    </div>
</div>



        </div>


        </div>